import { Row } from 'antd';
import React, { FC } from 'react';
import { TextRegular14 } from 'styles/typography';
import * as S from './MapMenu.styles';

interface IProps {
  title?: string;
}

const MapMenu: FC<IProps> = ({ title, children }) => {
  return (
    <S.Box>
      {Boolean(title) && (
        <Row justify="center" style={{ marginBottom: 24 }}>
          <TextRegular14>{title}</TextRegular14>
        </Row>
      )}
      {children}
    </S.Box>
  );
};

export const MapMenuRow = S.Row;

export default MapMenu;
